import styled from "styled-components";

interface ILabel {
  children: any;
  style?: any;
}

const Container = styled.p`
  color: ${(props) => props.theme.colors.title};
  font-size: 13px;
  font-weight: 600;
  width: 100px;
`;

const Label: React.FC<ILabel> = ({ children, style }) => {
  return <Container style={style}>{children}</Container>;
};

export default Label;
